import { inject } from 'vue'
import { useClientStore } from '@/stores/ClientStore'
import { get as _get, uniq as _uniq } from 'lodash'
import WebFontLoader from 'webfontloader'

const brandingSymbol = Symbol()

export const createBranding = {
  install: app => {
    const { getClient } = useClientStore()

    const { client } = getClient()

    const style = document.querySelector('html').style

    const colors = _get(client.value, 'style.colors', [])
    const typefaces = _get(client.value, 'style.typefaces', [])

    colors.forEach(color => {
      style.setProperty(`--${color.name}`, `hsl(${color.hue}, ${color.saturation}%, ${color.lightness}%)`)
      style.setProperty(`--${color.name}-h`, color.hue)
      style.setProperty(`--${color.name}-s`, color.saturation)
      style.setProperty(`--${color.name}-l`, color.lightness)
      style.setProperty(`--${color.name}-r`, color.red)
      style.setProperty(`--${color.name}-g`, color.blue)
      style.setProperty(`--${color.name}-b`, color.green)
    })

    typefaces.forEach(typo => {
      if (typo.name === 'primary') style.setProperty('--font-size-base', typo.size || '16px')

      style.setProperty(`--font-family-${typo.name}`, `"${typo.family}"`)
    })

    const loadFonts = ({ google }) => WebFontLoader.load({ google })

    const getFontFamily = (type = 'primary') => typefaces.find(({ name }) => name === type)?.family || 'Lato'

    loadFonts({ google: { families: _uniq(typefaces.map(typeface => typeface.file)) } })

    app.provide(brandingSymbol, {
      getFontFamily,
      loadFonts
    })
  }
}

export const useBranding = () => inject(brandingSymbol)
